import { CognitoUser } from 'amazon-cognito-identity-js';

const redirectOnLogin = async ({ redirect, user, errorMsg }) => {
  if (user instanceof CognitoUser) {
    return redirect('/');
  }

  throw new Error(`${errorMsg}: ${user}`);
};

export default redirectOnLogin;
